<template>
  <div>
    <!--  header-->
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="safety-certificate" />
            <span>{{ $t("message.logData.title1") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="compass" />
            <span>{{ $t("message.systemManagement.title2") }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <div class="page-title" style="margin-bottom: 20px">
      {{ $t("message.systemManagement.pageTitle") }}
    </div>


    <!--  role management modal-->
    <a-modal destroyOnClose :title="$t('message.systemManagement.roleEditTitle')" :visible="dialogUpdRole"
      :cancelText="$t('message.systemManagement.roleAddTitle1')" :okText="$t('message.systemManagement.roleAddTitle2')"
      @cancel="dialogUpdRole = false" @ok="editRole" :confirmLoading="editRoleFormLoading" :maskClosable="false"
      width="900px">
      <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item :label="$t('message.systemManagement.roleMgtTitle1')">
          <a-input :size="$globalSize" allowClear v-model="roleForm.role_name" />
        </a-form-item>
        <a-form-item :label="$t('message.systemManagement.roleAddTitle3')">
          <a-select :size="$globalSize" mode="multiple" @change="changeForceUpdate" v-model="roleForm.resources_id"
            :options="role_authority_options">
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('message.systemManagement.btnMgtTitle2')">
          <a-tree-select :size="$globalSize" :getPopupContainer="(triggerNode) => {
            return triggerNode.parentNode;
          }
            " show-search defaultExpandAll tree-checkable v-model="roleForm.buttons_data"
            :tree-data="roleForm.treeData" :placeholder="$t('message.systemManagement.btnMgtTitle4')"
            tree-default-expand-all>
          </a-tree-select>
        </a-form-item>

        <a-form-item :label="$t('message.systemManagement.roleMgtTitle3')">
          <a-textarea :size="$globalSize" v-model="roleForm.role_descp"
            :placeholder="$t('message.systemManagement.roleAddTitle7')" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal :title="$t('message.systemManagement.roleAddTitle')" destroyOnClose :visible="dialogAddRole"
      :cancelText="$t('message.systemManagement.roleAddTitle1')" :okText="$t('message.systemManagement.roleAddTitle2')"
      @cancel="dialogAddRole = false" @ok="addRoleFormFunction" :confirmLoading="addRoleFormLoading" width="900px"
      :maskClosable="false">
      <a-form-model ref="addRoleForm" :model="roleForm" :rules="addFormRules" :label-col="labelCol"
        :wrapper-col="wrapperCol">
        <a-form-model-item :label="$t('message.systemManagement.roleMgtTitle1')" prop="role_name">
          <a-input :size="$globalSize" allowClear v-model="roleForm.role_name" />
        </a-form-model-item>
        <a-form-model-item :label="$t('message.systemManagement.roleAddTitle3')">
          <a-select :size="$globalSize" mode="multiple" v-model="roleForm.resources_id"
            :options="role_authority_options">
          </a-select>
        </a-form-model-item>
        <a-form-item :label="$t('message.systemManagement.btnMgtTitle2')">
          <a-tree-select :size="$globalSize" :getPopupContainer="(triggerNode) => {
            return triggerNode.parentNode;
          }
            " show-search defaultExpandAll tree-checkable v-model="roleForm.buttons_data"
            :tree-data="roleForm.treeData" :placeholder="$t('message.systemManagement.btnMgtTitle4')"
            tree-default-expand-all>
          </a-tree-select>
        </a-form-item>

        <a-form-model-item :label="$t('message.systemManagement.roleMgtTitle3')">
          <a-textarea :size="$globalSize" v-model="roleForm.role_descp"
            :placeholder="$t('message.systemManagement.roleAddTitle7')" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!--  search card   -->
    <div class="search">
      <a-card>
        <a-row :gutter="32">
          <a-col class="gutter-row" :span="6">
            <a-input :size="$globalSize" type="text" ref="roleSearchInput"
              :placeholder="$t('message.systemManagement.roleSearchMsg')" allowClear>
              <div slot="addonBefore">
                {{ $t("message.systemManagement.roleMgtTitle1") }}：
              </div>
            </a-input>
          </a-col>
          <a-col class="gutter-row" :span="18">
            <a-button :size="$globalSize" style="float: left; width: 80px;" type="primary" @click="roleSearch">
              {{ $t("message.systemManagement.searchBtn") }}
            </a-button>
          </a-col>
        </a-row>
      </a-card>
    </div>

    <!--  content -->
    <div class="content" style="margin-top: 30px">
      <!--    table   -->
      <a-card>
        <a-layout>
          <a-layout-header>
            <a-row :gutter="16" style="
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                margin-bottom: 15px;
              ">
              <a-col :span="4">
                <div class="title font-weight-600">
                  {{ $t("message.systemManagement.roleMgtTitle") }}
                </div>
              </a-col>
              <a-col :span="20">
                <my-button :size="$globalSize" type="primary" style="float: right; margin: 21px 0 0 20px"
                  icon="plus-circle" @click="openAddRoleDialog"
                  :disabled="$store.getters.hasPermission($store.state.LIMIT_CONSTANTS.ROLE_LIMIT)">
                  {{ $t("message.systemManagement.roleMgtBtn") }}
                </my-button>
              </a-col>
            </a-row>
          </a-layout-header>
          <a-layout-content style="background-color: white">
            <a-table :columns="role_fields" :style="{
              marginTop: selectedRoleIds.length > 0 ? '95px' : '35px',
            }" :data-source="roles.filter(
              (role) =>
                !roleSerachValue ||
                role.role_name
                  .toLowerCase()
                  .includes(roleSerachValue.toLowerCase())
            )
              " rowKey="role_id" :loading="roleLoading" :pagination="false" :scroll="{ x: 1500 }">
              <template slot="created_at" slot-scope="text, record">
                <span>{{ convertToDefaultTimezone(showTime(record.created_at)) }}</span>
              </template>
              <template slot="role_authority" slot-scope="text, record">
                <span>
                  {{ record.role_authority }}
                </span>
              </template>
              <template slot="action" slot-scope="text, record, index">
                <my-button type="primary" shape="circle" class="edit-btn-icon"
                  @click="openUpdRoleDialog(text, record, index)" />
                <a-button type="primary" @click="delRole(record)" shape="circle" class="delete-btn-icon" />
              </template>
            </a-table>
          </a-layout-content>
          <a-layout-footer style="background-color: white">
            <my-pagination ref="myPaginationRef" @change="getRoleData" :total="totalCount"
              style="padding-top: 20px"></my-pagination>
          </a-layout-footer>
        </a-layout>
      </a-card>
    </div>
  </div>
</template>

<script>
import roleService from "@/interface/pages/Authority/UserAuthority/roleManagement";
import utils from "@/utils";
import MyPagination from "@/components/MyPagination";
import MyButton from "@/components/MyButton/index";
import { showTime } from "@/utils/common";
export default {
  name: "SysSettingMgt",
  components: {
    MyPagination,
    MyButton
  },
  data() {
    return {
      editRoleFormLoading: false,
      addRoleFormLoading: false,
      totalCount: 0,
      addFormRules: {
        role_name: [
          {
            required: true,
            message: () => this.$t("message.systemManagement.roleAddMsg1"),
            trigger: "blur",
          },
        ],
      },

      selectedRoleIds: [],
      roleSerachValue: "",
      roleLoading: false,
      roles: [],
      roleForm: {
        role_id: null,
        role_name: "",
        role_authority: [],
        role_descp: [],
        descp: "",
        creater: "",
        created_at: new Date(),
        buttons_data: [],
        treeData: [],
      },
      role_fields: [
        {
          dataIndex: "role_id",
          key: "role_id",
          title: () => this.$t("message.systemManagement.roleId"),
          align: "left",
          width: 400,
          sorter: (a, b) => a.role_id - b.role_id,
        },
        {
          dataIndex: "role_name",
          key: "role_name",
          title: () => this.$t("message.systemManagement.roleMgtTitle1"),
          align: "left",
        },
        {
          dataIndex: "role_descp",
          key: "role_descp",
          title: () => this.$t("message.systemManagement.roleMgtTitle3"),
          align: "left",
          scopedSlots: { customRender: "role_descp" },
        },
        {
          dataIndex: "created_user_name",
          key: "created_user_name",
          title: () => this.$t("message.systemManagement.roleMgtTitle6"),
          align: "left",
        },
        {
          dataIndex: "created_at",
          key: "created_at",
          title: () => this.$t("message.systemManagement.roleMgtTitle4"),
          align: "left",
          scopedSlots: { customRender: "created_at" },
        },
        {
          dataIndex: "action",
          key: "action",
          title: () => this.$t("message.systemManagement.roleMgtTitle5"),
          align: "center",
          width: 130,
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],

      //modal
      dialogAddRole: false,
      dialogUpdRole: false,
      role_authority_options: [],

      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 6
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 16 : 16
      },
    };
  },
  mounted() {
    utils.languageChange(this, { labelCol: 8, wrapperCol: 16 }, { labelCol: 6, wrapperCol: 16 })
  },
  methods: {
    changeForceUpdate() {
      this.$forceUpdate();
    },
    showTime,

    editRole() {
      const data = {
        roleId: this.roleForm.role_id,
        roleName: this.roleForm.role_name,
        roleDescp: this.roleForm.role_descp,
        resourceList: this.roleForm.resources_id,
        buttonList: this.roleForm.buttons_data,
        loginId: localStorage.getItem("userId"),
      };
      this.editRoleFormLoading = true;
      roleService
        .editRole(this, { data })
        .then(
          function (resp) {
            var res = resp.data;
            if (res.code == "200") {
              if (res.data > 0) {
                this.$message.success(
                  this.$t("message.systemManagement.sysMgtMsg1"),
                  1
                );
              }
            } else {
              this.$message.error(res.message);
            }
            this.dialogUpdRole = false;
            this.getRoleData();
          }.bind(this)
        )
        .catch((reason) => {
          console.log(reason);
          this.dialogUpdRole = false;
        }).finally(() => {
          this.editRoleFormLoading = false;
        });;
    },

    getRoleData() {
      this.roleLoading = true;
      roleService
        .getRoleData(this, {
          params: {
            ...this.$refs.myPaginationRef.pagination,
          },
        })
        .then(
          function (resp) {
            var res = resp.data;
            if (res.code == "200") {
              this.roles = res.data;
              this.totalCount = res.totalCount;
              setTimeout(() => {
                this.roleLoading = false;
              }, 800);
            } else {
              this.roleLoading = false;
              if (res.code !== '400') {
                this.$message.error(res.message);
              }
            }
          }.bind(this)
        )
        .catch((reason) => {
          this.roleLoading = false;
          console.log(reason);
        });
    },
    delRole(record) {
      let _self = this
      this.$confirm({
        title: this.$t('message.systemManagement.ConfirmDeleteRole'),
        okText: this.$t('message.commonUsage.confirm'),
        cancelText: this.$t('message.commonUsage.cancel'),
        onOk() {
          return new Promise((resolve, reject) => {
            var params = {
              roleId: record.role_id,
            };
            roleService
              .delRole(_self, { data: params })
              .then(
                function (resp) {
                  var res = resp.data;
                  if (res.code == "200") {
                    _self.$store.dispatch('fetchButtonPermission')
                    _self.$message.success(
                      _self.$t("message.systemManagement.sysMgtMsg2")
                    );
                    resolve()
                    _self.getRoleData();
                  } else {
                    _self.$message.error(res.message);
                    reject()
                  }
                }.bind(_self)
              )
              .catch((reason) => {
                console.log(reason);
                reject()
              });
          })
        },
        onCancel() {
        }
      });

    },

    getButtonOption() {
      return roleService
        .getButtonsOption(this, {
          params: {
          },
        })
        .then(
          function (resp) {
            var res = resp.data;
            if (res.code == "200") {
              return [res.data];
            }
          }.bind(this)
        )
        .catch((reason) => {
          console.log(reason);
        });
    },
    getRoleOption() {
      return roleService
        .getResourcesOption(this, {
          params: {
            userId: localStorage.getItem("userId"),
          },
        })
        .then(
          function (resp) {
            var res = resp.data;
            if (res.code == "200") {
              return res.data;
            }
          }.bind(this)
        )
        .catch((reason) => {
          console.log(reason);
        });
    },
    getRoleDataById(record) {
      let params = {
        roleId: record.role_id,
      };
      return roleService
        .getRoleById(this, { params: params })
        .then(
          function (resp) {
            var res = resp.data;
            if (res.code == "200") {
              return res.data;
            } else {
              this.$message.error(res.message);
            }
          }.bind(this)
        )
        .catch((reason) => {
          console.log(reason);
        });
    },
    openUpdRoleDialog(text, record) {
      return Promise.all([
        this.getRoleDataById(record),
        this.getRoleOption(),
        this.getButtonOption(),
      ])
        .then(([roleData, roleOptions, buttonOptions]) => {
          console.log(buttonOptions);
          let obj = {};
          this.role_authority_options = JSON.parse(
            JSON.stringify(roleOptions)
          ).map((option) => {
            return {
              ...option,
              value: option.resource_id,
              label: option.resource_name,
            };
          });
          obj = {
            ...JSON.parse(JSON.stringify(roleData)),
            treeData: buttonOptions,
            buttons_data: roleData.button_id_list,
            resources_id: roleData.resources_data.map(
              (item) => item.resource_id
            ),
          };
          this.roleForm = JSON.parse(JSON.stringify(obj));
          this.$nextTick(() => {
            this.dialogUpdRole = true;
          });
        })
        .catch((error) => {
          console.error("Error fetching role data or options:", error);
        });
    },
    openAddRoleDialog() {
      return Promise.all([this.getRoleOption(), this.getButtonOption()])
        .then(([roleOptions, buttonOptions]) => {
          let obj = {};
          this.role_authority_options = JSON.parse(
            JSON.stringify(roleOptions)
          ).map((option) => {
            return {
              ...option,
              value: option.resource_id,
              label: option.resource_name,
            };
          });
          obj = {
            treeData: buttonOptions,
          };
          this.roleForm = JSON.parse(JSON.stringify(obj));
          this.$nextTick(() => {
            this.dialogAddRole = true;
          });
        })
        .catch((error) => {
          console.error("Error fetching role data or options:", error);
        });
      // this.roleForm = {
      //   role_idrole_id: 10086,
      //   role_name: "",
      //   resources_id: [],
      //   creater: "",
      //   role_descp: "",
      //   created_at: new Date(),
      // };
    },
    addRoleFormFunction() {
      this.$refs.addRoleForm.validate((valid) => {
        let data = {
          roleName: this.roleForm.role_name,
          roleDescp: this.roleForm.role_descp,
          resourceList: this.roleForm.resources_id,
          buttonList: this.roleForm.buttons_data,
          loginId: localStorage.getItem("userId"),
        };
        if (valid) {
          this.addRoleFormLoading = true;
          roleService
            .addRole(this, { data })
            .then(
              function (resp) {
                var res = resp.data;
                if (res.code == "200") {
                  this.$store.dispatch('fetchButtonPermission')
                  this.dialogAddRole = false;
                  this.getRoleData();
                  if (res.data > 0) {
                    this.$message.success(
                      this.$t("message.systemManagement.sysMgtMsg1"),
                      1
                    );
                  }
                } else {
                  this.$message.error(res.message);
                }

              }.bind(this)
            )
            .catch((reason) => {
              console.log(reason);
              this.dialogAddRole = false;
            }).finally(() => {
              this.addRoleFormLoading = false;
            });
        }
      });
    },

    roleSearch() {
      var searchInput = this.$refs.roleSearchInput.$data.stateValue;
      this.roleSerachValue = searchInput;
    },
  },
};
</script>

<style scoped>
.blue-tag-style {
  font-size: 12px;
  color: #70b2ef;
  background: rgba(154, 205, 252, 0.2);
  border: 1px solid rgba(154, 205, 252, 0.3);
}
</style>
